import { ShieldCheck } from 'lucide-react';
import GenericModulePage from './GenericModulePage';
import { insuranceAPI } from '../lib/api';

const config = {
  title: 'Insurance / TPA',
  subtitle: 'Pre-authorisations and claims.',
  icon: ShieldCheck,
  permPrefix: 'insurance',
  testId: 'insurance',
  idLabel: 'Claim',
  // v37 batch 2 (May 21, 2026) — Print button per claim. Opens A4 print-friendly invoice in new tab.
  printPathBuilder: (claim) => `/insurance/print/${claim.id}`,
  fields: [
    { key: 'patient_name', label: 'Patient Name', type: 'text', required: true, listColumn: true },
    { key: 'patient_uhid', label: 'UHID', type: 'text', listColumn: true },
    { key: 'insurer', label: 'Insurer / TPA', type: 'text', required: true, listColumn: true },
    { key: 'policy_no', label: 'Policy Number', type: 'text', listColumn: true },
    { key: 'claim_type', label: 'Type', type: 'select', options: ['Cashless Pre-Auth', 'Cashless Final Bill', 'Reimbursement'], listColumn: true },
    { key: 'claim_amount', label: 'Claim Amount (₹)', type: 'number', listColumn: true },
    { key: 'approved_amount', label: 'Approved Amount (₹)', type: 'number' },
    { key: 'status', label: 'Status', type: 'select', options: ['Submitted', 'Queried', 'Approved', 'Rejected', 'Paid'], listColumn: true },
    { key: 'submitted_on', label: 'Submitted On', type: 'date' },
    { key: 'notes', label: 'Notes', type: 'textarea', fullWidth: true },
  ],
};

export default function InsurancePage() { return <GenericModulePage config={config} apiClient={insuranceAPI} />; }
